/* 환경 변수 파싱 (plan.md §9.1). 모두 공개 클라이언트 config — 비밀 아님.
   Vite 는 빌드 시 import.meta.env.VITE_* 를 정적 치환한다. */

const env = import.meta.env;

export const AWS_REGION = env.VITE_AWS_REGION || 'ap-northeast-2';
export const ADMIN_API_URL = (env.VITE_ADMIN_API_URL || '').replace(/\/$/, '');
export const CODE_BUCKET = env.VITE_CODE_BUCKET || 'huenit-lab-code';
/* 미지정 시 가상 호스팅 S3 URL 로 파생 — live 모드에서 익명 manifest GET 이
   상대경로(/official/manifest.json)로 새는 사고 방지. */
export const CODE_BUCKET_URL = (
  env.VITE_CODE_BUCKET_URL || `https://${CODE_BUCKET}.s3.${AWS_REGION}.amazonaws.com`
).replace(/\/$/, '');

/* 레지스트리 버킷 — 앱 설치파일(app/)·펌웨어(firmware/) 배포·버전 관리(별도 버킷).
   코드 예제 버킷(CODE_BUCKET)과 분리. 버전 관리 화면(features/versions)이 소비.
   CODE_BUCKET_URL 과 같은 파생 규칙(미지정 시 가상 호스팅 URL). */
export const REGISTRY_BUCKET = env.VITE_REGISTRY_BUCKET || 'huenit-lab-registry';
export const REGISTRY_BUCKET_URL = (
  env.VITE_REGISTRY_BUCKET_URL || `https://${REGISTRY_BUCKET}.s3.${AWS_REGION}.amazonaws.com`
).replace(/\/$/, '');

export const COGNITO_USER_POOL_ID = env.VITE_COGNITO_USER_POOL_ID || '';
export const COGNITO_CLIENT_ID = env.VITE_COGNITO_CLIENT_ID || '';
export const COGNITO_IDENTITY_POOL_ID = env.VITE_COGNITO_IDENTITY_POOL_ID || '';

/* Cognito ID 3종이 하나라도 비면 실연동 불가 → fake(오프라인 데모) 모드.
   plan.md §4.3 — 앱의 FakeAuthService/FakeCodeModelRegistry 분기 패턴과 동일. */
export const isFakeMode = !(
  COGNITO_USER_POOL_ID && COGNITO_CLIENT_ID && COGNITO_IDENTITY_POOL_ID
);
